import React, { Component } from 'react'
import { DropdownButton, MenuItem } from 'react-bootstrap'
import Button from '../../../components/Buttons'
import PanelOptions from './components/PanelOptions/panelOptions'
import SearchAutocomplete from './components/SearchAutoComplete/SearchAutocomplete.container'
import SearchResponsive from './components/SearchResponsive/searchResponsive'
import { translate } from 'react-translate'
import { browserHistory } from 'react-router'
import { pick, paramsForProperties } from '../../../actions/api'
import { PurposeSelector } from './components/PurposeSelector/PurposeSelector.component'
import {
  comercialPropertyTypes, residencialPropertyTypes, landOptionsKeys,
} from './SearchBar.constants'
import { purposeSelectorOptions, propertyTypesLandingMap } from './components/PurposeSelector/PurposeSelector.constants'

import './SearchBar.scss'

@translate('SearchBar')
class SearchBar extends Component {

  constructor (props) {
    super(props)

    this.state = {
      propertyPurpose: purposeSelectorOptions.residencial,
    }
    this._onClickSearch = this._onClickSearch.bind(this)
  }

  UNSAFE_componentWillMount() {
    if (this.props.show){
      this.props.closeMoreOptions()
    }
    this.props.resetForm()
    this.props.didMount(this.props.section)
    this.props.resetEntrepreneurshipId()
    this.props.onSelectPurpose && this.props.onSelectPurpose(purposeSelectorOptions.residencial)
  }

  filterPropertyTypesOptions(options, ) {
    if (!options || !options.length) return [];
    const reference = this.state.propertyPurpose === purposeSelectorOptions.residencial
      ? residencialPropertyTypes
      : comercialPropertyTypes

    return options.filter(
      option => reference.includes(option.name),
    )
  }

  filterPropertyTypesBySection(propertyTypes = [], section) {
    if (!propertyTypes || !propertyTypes.length) return []

    // first filter propertyTypes by section
    return section && propertyTypesLandingMap[section]
      ? propertyTypes.filter(op => propertyTypesLandingMap[section].includes(op.name))
      : propertyTypes
  }

  _onClickSearch() {
    const { landUses, setLandUse } = this.props
    // let landUsesQ = { land_uses: [] }
    //simplemente setear el default
    let typesOptions = this.props.property_types
    if (typesOptions.length === 1) {
      this.props.setPropertyType(typesOptions[0])
    }

    //verificación si hay que cambiar el originPath
    var currentPropertyTyppe = this.props.property_type
    if (currentPropertyTyppe.length && this.props.originPath.name == '/') {
      const currentPropertyTypeName = currentPropertyTyppe[0].name
      this.props.saveOriginPathByPropertyType(currentPropertyTypeName)
      if (this.props.showPurposeSelector && currentPropertyTypeName === 'Terreno' && landUses.length) {
        if (this.state.propertyPurpose === purposeSelectorOptions.residencial) {
          const mixtoValue = landUses.find(op => op.name === landOptionsKeys.mixto)
          const residencialValue = landUses.find(op => op.name === landOptionsKeys.residencial)
          // setLandUse(mixtoValue)
          setLandUse(residencialValue)
          // landUsesQ.land_uses.push(mixtoValue.id, residencialValue.id)
        } else { // this.state.propertyPurpose === comercial
          const mixtoValue = landUses.find(op => op.name === landOptionsKeys.mixto)
          const comercialValue = landUses.find(op => op.name === landOptionsKeys.comercial)
          // setLandUse(mixtoValue)
          setLandUse(comercialValue)
          // landUsesQ.land_uses.push(mixtoValue.id, comercialValue.id)
        }
      }
    }

    //traigo los parametros que ya estan cargados en el store de searchbar
    let q = pick(paramsForProperties(this.props.store))
    // q = { ...q, ...landUsesQ }
    // console.log('query ', q)
    //los parametros pasados son solo de visualizacion,
    //elijo que se vean los seleccionados por pick
    //la busqueda se va a realizar tomando los parametros params mas tarde
    //usando el mismo paramsForProperties por el componente Propiedades
    browserHistory.push('/propiedades?q='+JSON.stringify(q))
  }

  render(){
    const {
      operation,
      property_type,
      property_types,
      property_types_loading,
      operation_types,
      onSelectOperation,
      onSelectPropertyType,
      sub_property_type,
      onClickOpen,
      show,
      t,
      showPurposeSelector,
      section,
      onSelectPurpose,
    } = this.props

    let typesOptions = this.filterPropertyTypesBySection(property_types, section)

    typesOptions = showPurposeSelector
    ? this.filterPropertyTypesOptions(typesOptions)
    : typesOptions
    var placeholderPropertyType = ''
    if (typesOptions && typesOptions.length === 1) {
      placeholderPropertyType = typesOptions[0].name
    } else {
      placeholderPropertyType = t('Tipo_de_Propiedad')
    }

    let filterTitle = !show ? t('mas_filtros') : t('menos_filtros')

    var titleType = ''

    var isIncluded = []
    if(sub_property_type) isIncluded = property_types.filter(item => item.id == sub_property_type.id)
    if( sub_property_type && !property_type.length && sub_property_type.is_sector == 0 && isIncluded.length ) {
      titleType = sub_property_type.name
    }
    else if(property_type.length) {
      titleType = property_type[0].name
    } else titleType = placeholderPropertyType

    let titleOperation = (operation.length !== 0 && operation[0].name)
      ? t(operation[0].name.replace(' ','_'))
      : t('Venta')

    return(
      <div className='search-bar-box main-search-container'>
        {
          showPurposeSelector &&
          <PurposeSelector
            value={this.state.propertyPurpose}
            onSelectOption={(selection) => {
              this.setState({ propertyPurpose: selection })
              this.props.resetPropertyType()
              if (onSelectPurpose) {
                onSelectPurpose(selection)
              }
            }}
          />
        }
        <div className='search-bar ljr-search-bar hidden-xs'>
          <div className='search-item-wrapper'>
            <div className='search-bar-item'>
              <div className='search-bar-label'>
                {t('Operation')}
              </div>
              <DropdownButton
                title={titleOperation}
                className='dropdown-basic-type searchbar-operations-type-selector'
                onSelect={ onSelectOperation }
              >
                {operation_types && operation_types.length && operation_types.map((item) =>
                  <MenuItem eventKey={item} key={item.id}>{t(item.name.replace(' ','_'))}</MenuItem>
                )}
              </DropdownButton>
            </div>
          </div>
          <div className='search-item-wrapper wrapper-multiple'>
            <div className='search-bar-item'>
              <div className='search-bar-label'>
                {t('Tipo_de_Propiedad')}
              </div>
              {(property_types_loading)
                ? <DropdownButton
                    className='dropdown-basic-type searchbar-property-type-selector'
                    autosize={false}
                    multi={true}
                    disabled={true}
                    clearable={false}
                    value={'cargando...'}
                    placeholder={'Cargando...'}
                    title={'Cargando...'}
                    options={[]}
                  >
                    <MenuItem
                      className='div-option' eventKey={'eventkey1'} key={'key1'}>
                        {'name1'}
                      </MenuItem>
                  </DropdownButton>
                : (
                    !!typesOptions && !!typesOptions.length &&
                    <DropdownButton
                      title={titleType}
                      className='dropdown-basic-type searchbar-property-type-selector' onSelect={ onSelectPropertyType }
                    >
                      {typesOptions.map((item) => {
                        return (<MenuItem className='div-option' eventKey={item} key={item.id}>{item.name}</MenuItem>)
                      })}
                    </DropdownButton>
                  )
              }
            </div>
            <div className='search-bar-item'>
              <div className='search-bar-label'>
                {t('Busque_zona')}
              </div>
              <SearchAutocomplete />
            </div>
          </div>
          <div className='search-item-btn-wrapper'>  
            <div className='search-bar-item'>
              <div className='search-bar-action'>
                <Button clickButton={onClickOpen} text={filterTitle} />
              </div>
              <Button
                type='submit'
                text={t('Buscar')}
                classes='btn-primary btn-search'
                clickButton={() => this._onClickSearch()}
              />
            </div>
          </div>
        </div>
        <div className='searchbar-responsive ljr-search-bar visible-xs'>
          <SearchResponsive
            clicked={() => this._onClickSearch()}
            open={show}
            onOpenOptions={onClickOpen}
            onClickOperation={onSelectOperation}
            operation={operation}
            property_types={typesOptions}
            property_types_loading={property_types_loading}
            sub_property_type={sub_property_type}
            property_type={property_type}
            type_selected={property_type}
            onSelectPropertyType={onSelectPropertyType}
            operation_types={operation_types}
          />
        </div>
        <div className='panel-wrapper'>
          <PanelOptions open={show} />
        </div>
      </div>
    )
  }
}

export default SearchBar



// WEBPACK FOOTER //
// ./src/features/commons/SearchBar/SearchBar.component.js